import Layout from 'components/layout/Layout';

export default Layout;
